import React from 'react';
import './App.css'
import Home from './Pages/Home';
import SignIn from "./Pages/SignIn";
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import ProtectedRoutes from './services/ProtectedRoutes';
// import {CssBaseline} from '@material-ui/core';


function App() {
  return (
    <>
    {/* <CssBaseline /> */}
    <Router>
        <Routes>
        <Route exact path="/" element={<ProtectedRoutes/>}>
          <Route exact path="/" element={<Home/>}/>
          </Route>
          <Route exact path="/login" element={<SignIn/>}/>  
        </Routes>
        </Router>
    </>
  )
}
export default App;
